BaseModel = require './base_model.coffee'

class global.SalesforceSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    authorized: {}
    status: {}
    access_token: {}
    mark_as: { default: 'only_lead' }
    send_to: { default: 'responsible' }
    triggers: { default: { on_created: false, status: ['connected'], stages: ['lost'] }, type: Object }
    properties_matching: { default: [], type: Array }
    sandbox_test: { default: false }
  }



// WEBPACK FOOTER //
// ./src/models/salesforce_setting.coffee